import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useKitchenItemRequestContext from 'contexts/kitchen/item-request.context/context';
import RequestDetailsWrapper from 'components/base/request-details-wrapper';
import BrandChefRequestList from './brand-chef-request-list';
import SendBrandChefItems from './send-brand-chef-items';
import { MAIN_STORE_ROUTE_KEYS } from 'utils/constants';
import { ENUM_REQUEST_STATUS } from 'models/common.model';

const KitchenReviewItemRequestDetails = () => {
  const { itemRequestToEdit, setItemRequestToEdit } = useKitchenItemRequestContext();
  const [step, setStep] = useState(1);
  const [selectedItemId, setSelectedItemId] = useState('');
  const [currentStatus, setCurrentStatus] = useState(itemRequestToEdit?.status);
  const navigate = useNavigate();

  useEffect(() => {
    if (!itemRequestToEdit || !itemRequestToEdit.id) {
      navigate(MAIN_STORE_ROUTE_KEYS.KITCHEN_MANAGE_ITEM_REQUESTS, { replace: true });
    }
  }, [itemRequestToEdit, navigate]);

  if (!itemRequestToEdit || !itemRequestToEdit.id) {
    return null;
  }

  const handleSendItems = (itemId: string) => {
    setSelectedItemId(itemId);
    setStep(2);
  };

  const handleSuccess = () => {
    const newStatus = ENUM_REQUEST_STATUS.SENT;
    setItemRequestToEdit((prev) => ({
      ...prev,
      status: newStatus
    }));
    setCurrentStatus(newStatus);
    setStep(1);
  };

  const handleCancel = () => {
    if (step === 1) {
      navigate(-1);
    } else {
      setSelectedItemId('');
      setStep(1);
    }
  };

  return (
    <RequestDetailsWrapper
      codeId={itemRequestToEdit.code}
      status={currentStatus || itemRequestToEdit?.status}
      header={step === 1 ? 'Review Items' : 'Confirm Received Items'}
      subHeader={
        step === 1
          ? 'Review and confirm items sent by brand chefs'
          : 'Enter quantity received for verification'
      }
      pageTitle='Track and verify items from brand chefs'
      backLinkTitle='Return to item requests'>
      {step === 1 && <BrandChefRequestList onSendItems={handleSendItems} />}

      {step === 2 && (
        <SendBrandChefItems
          selectedItemId={selectedItemId}
          onSuccess={handleSuccess}
          onCancel={handleCancel}
        />
      )}
    </RequestDetailsWrapper>
  );
};

export default KitchenReviewItemRequestDetails;
